import React from "react";
import moment from "moment";
import * as Icon from "react-feather";

import "./build-drafts.css";

class BuildDrafts extends React.PureComponent {
	render() {
		const { drafts, describeDraft, onOpen } = this.props;
		if (drafts.length === 0) return null;

		return (
			<section className="build-drafts">
				<div className="build-drafts__head">
					<span className="build-drafts__name">Your drafts</span>
					<span className="build-drafts__count">{drafts.length}</span>
				</div>
				<div className="tk-card">
					{drafts.map(draft => (
						<button key={draft.id} type="button" className="build-drafts__row" onClick={() => onOpen({ sessionId: draft.id })}>
							<span className="tk-icon-tile tk-icon-tile--sm">
								<Icon.Edit3 />
							</span>
							<span className="build-drafts__title">
								{draft.title ? draft.title : <span className="build-drafts__untitled">Untitled</span>}
								{draft.summary && <span className="build-drafts__summary">{draft.summary}</span>}
							</span>
							<span className="build-drafts__meta">
								{describeDraft({ draft })} · {moment(draft.updatedAt).fromNow()}
							</span>
							<Icon.ChevronRight size={16} className="build-drafts__chevron" />
						</button>
					))}
				</div>
			</section>
		);
	}
}

export default BuildDrafts;
